import { render, staticRenderFns } from "./RolesBox.vue?vue&type=template&id=6c7dfd46&scoped=true&"
import script from "./RolesBox.vue?vue&type=script&lang=js&"
export * from "./RolesBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7dfd46",
  null
  
)

export default component.exports